import { useNavigate } from "react-router-dom";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-10"><Logo /></div>
        <h1 className="font-serif text-2xl font-bold" data-testid="payment-cancelled-title">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-muted-foreground">No payment was taken. You can choose a plan whenever you're ready.</p>
        <div className="mt-8 flex justify-center gap-3">
          <Button data-testid="cancel-back-to-pricing-btn" onClick={() => navigate("/pricing")}>Back to pricing</Button>
          <Button variant="outline" data-testid="cancel-home-btn" onClick={() => navigate("/")}>Home</Button>
        </div>
      </div>
    </div>
  );
}
